export default __webpack_public_path__ + "static/media/icon-videos.7507db08.svg";